var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlanInfoActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#038AB7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.792 14.5c-.576 0-1.042.466-1.042 1.041v8.334c0 .574-.467 1.042-1.042 1.042H6.125a1.043 1.043 0 0 1-1.042-1.042V9.29c0-.574.467-1.042 1.042-1.042h8.333a1.041 1.041 0 1 0 0-2.083H6.125A3.129 3.129 0 0 0 3 9.291v14.584A3.129 3.129 0 0 0 6.125 27h14.583a3.129 3.129 0 0 0 3.125-3.125V15.54a1.04 1.04 0 0 0-1.041-1.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.767 13.55a.527.527 0 0 0-.143.266l-.737 3.684a.522.522 0 0 0 .614.612l3.682-.736a.518.518 0 0 0 .267-.143l8.242-8.242-3.683-3.682-8.242 8.242zM27.238 2.762a2.606 2.606 0 0 0-3.683 0l-1.441 1.441 3.682 3.683 1.442-1.442c.491-.49.762-1.145.762-1.84 0-.696-.27-1.35-.762-1.842z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlanInfoActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-plan-info-active.b8d1eec43adcd24ea75c37f40550db08.svg";